const ja = {
  Language: {
    vi: "ベトナム語",
    en: "英語",
    zh: "中国語（簡体字）",
    "zh-HK": "中国語（繁体字、香港）",
    ko: "韓国語",
    ja: "日本語",
  },
  NAVS: {
    home: "ホーム",
    ourHotels: "ホテル紹介",
    contactUs: "お問い合わせ",
    aboutUs: "会社概要",
    sustainability: "持続可能性",
    careers: "採用情報",
    discoverOurHotels: "ホテルを探索",
    amanakiSaigonBoutique: "アマナキ サイゴン ブティック",
    amanakiThaoDien: "アマナキ タオディエン",
    amanakiHotel: "アマナキ ホテル",
    theHotel: "ホテル",
    brandStory: "ブランドストーリー",
    artAmanaki: "アート & アマナキ",
    rooms: "客室",
    wellness: "ウェルネス",
    dining: "ダイニング",
    events: "イベント",
    offers: "オファー",
    discoverSaigon: "サイゴンを探索",
  },
  Form: {
    required: "必須項目",
    emailInvalid: "メールアドレスの形式が正しくありません。",
    mustBeAccept: "同意が必要です",
    placeholderFirstName: "名",
    placeholderLastName: "姓",
    placeholderEmail: "メールアドレス",
    placeholderPhone: "電話番号",
    placeholderEnquiry: "お問い合わせ種別を選択",
    placeholderWhichHotel: "どちらのホテルにお問い合わせされますか？",
    placeholderMessage: "メッセージ",
    placeholderDepartureDate: "チェックアウト日",
    placeholderArrivalDate: "チェックイン日",
    placeholderRoomType: "客室タイプを選択",
    placeholderAll: "すべて",
    labelPhone: "電話",
  },
  Options: {
    Enquiry: {
      hotelReservation: "ホテル予約",
      wellnessReservation: "ウェルネス予約",
      meetingsEvents: "会議・イベント",
      pressMedia: "プレス・メディア",
      generalEnquiryFeedback: "一般お問い合わせ・フィードバック",
    },
  },
  Notification: {
    submitSuccess: "情報が送信されました。",
  },
  Footer: {
    name: "アマナキ ホテル",
    address: "タオディエン区、トゥドゥック市、ホーチミン市",
    address10: "10 Nguyen Dang Giai, タオディエン区, ホーチミン, ベトナム",
    address65: "65 Ho Tung Mau, ベンゲー区, 1区, ホーチミン",
    email: "info@amanaki.vn",
    email10: "info@amanaki.vn",
    email65: "sales@amanakihotels.com",
    phone: "(+84) 82 362 4488",
    phone10: "(+84) 82 362 4488",
    phone65: "(+84) 28 363 4488",
    tel: "電話",
    ourHotels: "ホテル紹介",
    thaoDien: "アマナキ タオディエン",
    boutiqueSaigon: "アマナキ サイゴン ブティック",
    amanakiHotels: "アマナキ ホテル",
    getToKnowUs: "会社概要",
    whoWeAre: "会社概要",
    sustainabilityImpact: "持続可能性への影響",
    ourStories: "ストーリー",
    explore: "探索",
    careers: "採用情報",
    ourOffice: "オフィス",
    getInTouch: "お問い合わせ",
    contactUs: "お問い合わせ",
    copyright: "© 2023 アマナキ ホテル。全著作権所有。",
    privacyPolicy: "プライバシーポリシー",
    adCookiePolicy: "広告・Cookieポリシー",
    legalNotices: "法的通知",
  },
  Header: {
    selectAHotel: "ホテルを選択",
    aboutAmanaki: "アマナキについて",
    ourStories: "ブログ",
    contactUs: "お問い合わせ",
    ourBlog: "ブログ",
    aboutUs: "会社概要",
    sustainability: "持続可能性",
    careers: "採用情報",
  },
  Button: {
    bookNow: "今すぐ予約",
    discoverMore: "もっと見る",
    moreDetail: "詳細を見る",
    moreDetails: "詳細を見る",
    allOffer: "すべてのオファーを見る",
    viewThisRoom: "この客室を見る",
    applyNow: "今すぐ応募",
    viewMap: "地図を見る",
    contactUs: "お問い合わせ",
    moreAboutUs: "もっと見る",
    enterOurSpaces: "スペースを探索",
    bookThisRoom: "この客室を予約",
    exploreArtsAndAmanaki: "アート & アマナキを探索",
    viewAllStories: "すべてのストーリーを見る",
    viewAll: "すべて見る",
    reserve: "予約",
    readMore: "続きを読む",
    exploreMore: "もっと探索",
    viewCareers: "採用情報を見る",
    makeAnEnquire: "お問い合わせ",
    getToKnowOurExecutiveChef: "シェフを知る",
    visitOurRestaurant: "レストランを訪問",
    seeOurFacilities: "施設を見る",
    submit: "送信",
    checkTheMap: "地図を確認",
    goToMap: "地図へ移動",
    requestForProposal: "提案を依頼",
    bookDirectWithUs: "直接予約",
    back: "戻る",
    backToTop: "トップに戻る",
  },
  FAQs: {
    FAQs: "よくある質問",
    slogan: "お客様のあらゆるニーズにお応えします！",
  },
  Stories: {
    title: "インスピレーションを与えるストーリー",
    topic: {
      wellness: "ウェルネス",
      liveLikeLocal: "地元の人々のように暮らす",
      whatOn: "最新情報",
    },
    lastestStories: "最新のストーリー",
    interested: "興味のある分野",
    exploreAllStories: "すべてのストーリーを探索",
    tags: "タグ",
    share: "ストーリーを共有",
  },
  About: {
    aboutAmanaki: "アマナキについて",
    aboutUs: "会社概要",
    sustainableDevelopment: "持続可能な開発",
    careers: "採用情報",
    sustainable: {
      blogs: {
        heading: "こちらもおすすめ",
      },
    },
  },
  Wellness: {
    wellness: "ウェルネス",
    facilitiesService: "施設・サービス",
    gallery: "ギャラリー",
    hours: "営業時間",
    reservations: "予約",
    location: "場所",
    wellbeingCentre: {
      wellbeingCentre: "ウェルビーイングセンター",
    },
    facilities: {
      facilities: "施設",
    },
  },
  Dinning: {
    dinning: "ダイニング",
    restaurantInfo: {
      title: "レストラン情報",
      cuisine: {
        label: "料理",
        fusionInspired: "ベトナムフュージョン",
        viewMenu: "メニューを見る",
      },
      reservations: {
        label: "予約",
        phone: "082 841 1010",
        email: "info@amanaki.vn",
        address: "8 Nguyen Dang Giai, タオディエン, 2区",
      },
      openingHours: {
        label: "営業時間",
        allDay: "終日",
        dinning: "06:00 - 22:00",
        lastOrder: "（最終注文 21:45）",
      },
      executiveChef: {
        label: "シェフ",
        name: "Dong Hoang Nam",
      },
      moreInfo: {
        label: "詳細情報",
        amanakiFacebook: "アマナキ Facebook",
      },
    },
  },
  MeetingAndEvents: {
    meetingAndEvents: "会議・イベント",
    meetingAndCelebrations: "イベント・お祝い",
    labelBanner: "インスピレーションを与えるイベントのための創造的な空間",
    overview: {
      title: "アマナキ タオディエンのイベント・お祝い",
      desc: "文字通り、そして比喩的に、11:11 Espaceはアマナキ タオディエンの中心に存在します - ストーリーが創造され、交換される境界の共存空間です。250平方メートルの展示・イベントスペースは、11:11 Espaceがキュレーションし、提示する現代ベトナムおよび国際アーティストが創造的才能を披露する場所です。スタイリッシュなアート＆ソーシャルイベントをお望みの方は、ぜひお声がけください！",
      phone: "(+84) 82 362 4488",
      email: "info@amanaki.vn",
    },
    requestForProposal: {
      form: {
        fullName: "氏名",
        emailAddress: "メールアドレス",
        phoneNumber: "電話番号",
        numberOfAttendees: "予想参加者数",
        desiredSetup: "希望セットアップ",
        desiredSetupOptions: JSON.stringify([
          { label: "宴会", value: "Banquet" },
          { label: "カクテルレセプション", value: "CocktailReception" },
          { label: "シアター形式", value: "Theatre" },
          { label: "U字型", value: "Ushape" },
          { label: "その他", value: "Other" },
        ]),
        eventDate: "イベント日",
        note: "イベント概要、コメント、質問および/または特別なリクエスト",
        condition: {
          readAndAccept: "以下を読み、同意しました",
          privacyPolicy: "プライバシーポリシー",
          keepUpToDateInfo: "ニュースと情報を最新の状態に保ちたいと思います",
        },
      },
    },
  },
  BrandStory: {
    banner: {
      title: "ブランドストーリー",
    },
  },
  Arts: {
    banner: {
      title: "アート & アマナキ",
    },
    exhibitions: {
      tabs: JSON.stringify([
        { label: "今後の展覧会", value: "upcomingExhibition" },
        { label: "現在の展覧会", value: "currentExhibition" },
        { label: "過去の展覧会", value: "previousExhibition" },
      ]),
      status: {
        ongoing: "開催中",
        exhibition: "展覧会",
      },
    },
  },
  LegalNotice: {
    banner: {
      title: "法的通知",
    },
    menuOptions: JSON.stringify([
      { label: "プライバシーポリシー", value: "PrivacyPolicy" },
      { label: "Cookie", value: "Cookies" },
      { label: "最安価格保証", value: "BestRateGuaranteed" },
    ]),
    cookies: {
      heading: "Cookie",
      data: JSON.stringify([
        {
          title: `1. Cookieとは何ですか？`,
          content: `Cookieは、ウェブサイトを訪問したときにコンピューターやモバイルデバイス <i>（スマートフォンやタブレットなど）</i> に保存される小さなテキストファイルまたは情報の断片です。Cookieには通常、Cookieが発信元のウェブサイトの名前、Cookieの「有効期限」 <i>（つまり、Cookieがデバイスにどのくらい長く残るか）</i>、そして通常はランダムに生成された一意の番号である値が含まれます。`,
        },
        {
          title: `2. Cookieを使用する目的は何ですか？`,
          content: `Cookieを使用して、ウェブサイトをより使いやすくし、ウェブサイトと製品をお客様の興味やニーズに合わせてより適切にカスタマイズします。Cookieは、ウェブサイトがこれらのファイルを読み書きできるため、お客様を認識し、ウェブサイトの使用をより便利にする重要な情報を記憶することができます <i>（たとえば、設定を記憶することによって）</i>。Cookieは、ウェブサイトでの今後の活動や体験を高速化するためにも使用される場合があります。また、Cookieを使用して、ユーザーがウェブサイトをどのように使用しているかを理解し、ウェブサイトの構造とコンテンツを改善するのに役立つ匿名の集計統計をコンパイルします。この情報からお客様を個人的に識別することはできません。`,
        },
        {
          title: `3. どのような種類のCookieを使用していますか？`,
          content: `ウェブサイトでは、「セッションCookie」と「永続Cookie」と呼ばれる2種類のCookieが使用される場合があります。セッションCookieは、サイトを離れるまでデバイスに残る一時的なCookieです。永続Cookieは、デバイスに長期間残るか、手動で削除するまで残ります <i>（Cookieがデバイスにどのくらい長く残るかは、特定のCookieの期間または「有効期限」によって異なります）</i>。
サードパーティCookie
また、多くのサプライヤーを使用しており、ウェブサイトを訪問したときに、当社に代わってデバイスにCookieを設定し、提供しているサービスを提供できるようにする場合があります。これらのCookieの詳細情報、およびそのようなCookieの受信をオプトアウトする方法については、それぞれのプライバシーポリシーを参照してください。`,
        },
        {
          title: `4. どのCookieを使用していますか？`,
          content: [
            {
              text: `以下に、Amanaki.vnウェブサイトで使用される可能性のあるさまざまな種類のCookieをリストします。Cookieを通じて収集された情報が個人情報を構成する範囲内で、プライバシーポリシーの規定が適用され、このCookieポリシーを補完します。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">必須Cookie：</span>
必須Cookieは、サイトが機能し、サイトを移動してサービスや機能を使用できるようにするために必要です。これらの絶対に必要なCookieがないと、サイトが期待どおりにスムーズに機能しない可能性があり、要求したサイトまたは特定のサービスや機能を提供できない場合があります。
<span style="font-weight: 405;">セッション</span> – セッションCookieは、アプリケーションの状態を維持するために使用されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">ロードバランシング</span> – ロードバランシングCookieは、資産を世界中に分散し、サーバーの負荷を軽減するために使用されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">ユーザーID</span> – ユーザーID Cookieは、ユーザーが自分の情報のみを表示できるようにするために使用されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">セキュリティ</span> – セキュリティCookieは、セキュリティ制御とチェックに使用されます。ブラウザ設定で受け入れ/拒否して管理できます。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">設定Cookie</span>
設定Cookieは、選択と設定に関する情報を収集し、言語やその他のローカル設定を記憶し、それに応じてサイトをカスタマイズできるようにします。
<span style="font-weight: 405;">言語</span> – 言語Cookieは、ユーザーが選択した言語を保存し、正しいオプションを表示するために使用されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">場所</span> – IPアドレスによって決定されたユーザーのおおよその住所 <i>（都市、州、国/地域、郵便番号）</i> は、適切な国/地域を自動的に選択し、その地域内の小売業者やデモンストレーション日を表示するために保持されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">モバイル</span> – ユーザーがモバイルデバイスでサイトを表示している場合、メインウェブサイトが選択されたことを示すCookieが設定されます <i>（つまり、デバイスがFlash対応）</i>、または非Flashモバイルサイトです。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">参照サイト</span> – 参照サイトは、ユーザーの設定をよりよく理解するために記録されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">最後の訪問とアクティビティ</span> – 最後の訪問とアクティビティの日付、およびその他の情報が記録され、「最後の訪問以降にサイトで変更された内容」についての更新をユーザーに提供し、ユーザーの設定をよりよく理解できるようにします。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">最近視聴した動画</span> – 最近視聴した動画の日付とタイトルが記録され、ユーザーの設定をよりよく理解できるようにします。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">Flash Cookie</span> – Flash Cookieは、オーディオおよびビデオコンテンツの再生を有効にするために使用されます。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">ページ履歴</span> – ページ履歴Cookieは、ユーザーが訪問したページのシーケンスを追跡するために使用されます。ユーザーがサイトを訪問中にエラーメッセージを受け取った場合、Cookie情報はエラー報告と解決のためにログファイルに保存されます。ブラウザ設定で受け入れ/拒否して管理できます。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">ソーシャルプラグイン追跡Cookie</span>
このようなCookieは、市場調査分析および製品開発のために、ソーシャルメディアネットワークのメンバー[および非メンバー]を追跡するために使用されます。
<span style="font-weight: 405;">Facebook</span> – Cookieは、市場調査分析および製品開発のために、Facebookメンバー[および非メンバー]を追跡するために使用されます。ブラウザ設定で受け入れ/拒否して管理できます。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">分析Cookie</span>
分析Cookieは、サイトの使用に関する情報を収集し、その動作方法を改善できるようにします。たとえば、分析Cookieは、サイトで最も頻繁に訪問されるページを示し、サイトで発生した困難を記録するのに役立ち、広告が効果的かどうかを示します。これにより、単一のユーザーの使用ではなく、サイトの全体的な使用パターンを確認できます。
<span style="font-weight: 405;">Google Analytics</span> – Google Analytics Cookieは、サイトのプレゼンテーションとナビゲーションを改善するために、集計統計データを収集します。Googleは、集計データに人口統計と興味の情報を補完して、訪問者をよりよく理解できるようにします。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">Adobe Omniture</span> – Adobe Omniture分析Cookieは、サイトのプレゼンテーションとナビゲーションを改善するために、集計統計データを収集します。ブラウザ設定で受け入れ/拒否して管理できます。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">マーケティングCookie</span>
広告Cookieは、マーケティング目的で使用されます。
<span style="font-weight: 405;">広告</span> – 行動/ターゲット広告を提供します。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">市場分析</span> – 市場分析を実施します。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">キャンペーン/プロモーション</span> – キャンペーンの効果を測定します。ブラウザ設定で受け入れ/拒否して管理できます。
<span style="font-weight: 405;">不正検出</span> – クリック不正を検出します。ブラウザ設定で受け入れ/拒否して管理できます。`,
            },
          ],
        },
        {
          title: `5. Cookieを管理する方法は？`,
          content: `ほとんどのインターネットブラウザは、最初にCookieを自動的に受け入れるように設定されていますが、ほとんどのインターネットブラウザでは、設定を変更してCookieをブロックしたり、Cookieがデバイスに送信されるときにアラートを表示したりできます。
上記で提供されたオプションに加えて、ブラウザの設定をアクティブ化またはアクセスすることで、いつでもサイトのCookieを拒否、受け入れ、または削除できます。Cookieを有効化、無効化、または削除するために従う必要がある手順に関する情報は、ヘルプ画面を通じてインターネットブラウザプロバイダーのウェブサイトで見つけることができます。
Cookieが無効化または削除された場合、サイトのすべての機能が意図したとおりに動作しない可能性があることに注意してください。たとえば、サイトの特定の領域にアクセスできない場合や、サイトを訪問したときにパーソナライズされた情報を受け取れない場合があります。
異なるデバイスを使用してウェブサイトを表示およびアクセスする場合 <i>（例：コンピューター、スマートフォン、タブレットなど）</i>、各デバイスの各ブラウザがCookie設定に合わせて調整されていることを確認する必要があります。
訪問したウェブサイトが残したすべてのCookieをクリーンアップしたい場合は、追跡Cookieをクリーンアップするサードパーティウェブサイトを見つけることができます。
これらのサードパーティウェブサイトは当社の管理下になく、これらのウェブサイトに関していかなる表明や保証も行いません。これらのサードパーティウェブサイトにアクセスすることを決定した場合、サイトを使用する前に、それぞれのサードパーティサイトの利用規約とプライバシーポリシーを確認することをお勧めします。`,
        },
        {
          title: `6. ピクセルタグ`,
          content: `サイトで訪問する一部のページは、プロモーション活動とウェブサイト開発を直接サポートするサードパーティと共有される可能性のあるピクセルタグ <i>（クリアGIFとも呼ばれます）</i> の使用を通じて情報を収集する場合もあります。たとえば、ウェブサイト訪問者に関するウェブサイト使用情報は、ウェブサイトのインターネットバナー広告をより適切にターゲットするために、サードパーティ広告代理店と共有される場合があります。ただし、これらのピクセルタグの使用を通じて収集された情報は、個人的に識別可能ではありませんが、個人情報にリンクされる可能性があります。`,
        },
        {
          title: `7. お問い合わせ`,
          content: `このCookieポリシーに関するご質問がございましたら、<a href="mailto:info@amanaki.vn" style="color: #af915e">info@amanaki.vn</a>までお問い合わせください。メール通信は常に安全であるとは限らないため、メールにクレジットカード情報や機密情報を含めないでください。`,
        },
      ]),
    },
    bestRateGuaranteed: {
      heading: "最安価格保証",
      title: "アマナキに直接予約して最安価格を保証。",
      data: JSON.stringify([
        {
          content: `アマナキでのご滞在は、最初から最後まで当社の優先事項です。公式ウェブサイトで直接ご滞在を予約すると、その旅が始まります。以下が保証されます：`,
        },
        {
          content: [
            `ご滞在に可能な限り最低の料金`,
            `最も柔軟なキャンセル条件`,
            `予約をサポートする専用予約スペシャリストへのアクセス`,
            `滞在中の最高のサービスへのアクセス`,
            `予約後24時間以内により低い適格料金を見つけた場合、より低い料金に合わせます。`,
          ],
        },
      ]),
    },
  },
  HomeHotel10: {
    experiencing: {
      title: "アマナキを体験",
    },
  },
  Offers: {
    offer: "オファー",
  },
  Offer: {
    valid: "{{date}}まで有効",
    otherOffer: "その他のオファー",
  },
  ContactUs: {
    description: `ホテル、ホテル予約、またはレストランやウェルビーイングセンターでの予約に関するご質問がございましたら、お問い合わせください。`,
    getInTouch: "お問い合わせ",
    descInTouch: `お客様からのご連絡をお待ちしております。以下の詳細情報を使用してお問い合わせください。`,
    iConfirm: "アマナキホテルの以下を読み、理解したことを確認します",
    privacy: "プライバシーポリシー",
    acceptReceiveInfomation:
      "はい！ホテル、ダイニング、スパプロモーションを含む、アマナキホテルからの特別オファーとプロモーションを受け取りたいと思います",
    addressAmanakiThaoDien: `10 Nguyen Đang Giai, タオディエン区, トゥドゥック市, ホーチミン市`,
    addressAmanakiSaigonBoutique: `65 Ho Tung Mau, ベンゲー区, 1区, ホーチミン`,
  },
  Discover: {
    title: "サイゴンを探索",
    description:
      "\"すべての建物、すべての店先が、異なる世界に開かれているように見え、人間の生活のあらゆる多様性を、接続詞によってさらに豊かになった可能性の混乱に圧縮していました。\"<0/>Rebecca Solnit",
    BlockLocation: {
      distanceAmanaki: "アマナキからの方向：",
      checkMap: "地図を確認",
    },
    BlockOurLocation: {
      ourLocation: "当社の場所",
      getting: "アマナキ<0/>タオディエンホテルへのアクセス",
      address: "10 Nguyen Dang Giai通り, タオディエン区, トゥドゥック市, ホーチミン市",
      phone: "(+84) 82 3624488",
      airport: "タンソンニャット国際空港",
      airportDescription: `タンソンニャット国際空港から<0/>
ホテルまでの距離：13km<0/>
空港シャトルサービス：500,000VND/回`,
      tel: "電話",
    },
  },
  Breadcrumb: {
    stories: "ストーリー",
    category: "カテゴリー",
    amanakiThaoDien: "アマナキ タオディエン",
    "amanaki-thao-dien": "アマナキ タオディエン",
    "amanaki-boutique-saigon": "アマナキ サイゴン ブティック",
    theHotel: "ホテル",
  },
  Rooms: {
    Signature: "シグネチャー",
    Executive: "エグゼクティブ",
    Premium: "プレミアム",
    FamilySuite: "ファミリースイート",
    otherRooms: "その他の客室",
    theDetails: "詳細",
    utilities: "ユーティリティ",
    amenities: "アメニティ",
    checkIn: "チェックイン",
    checkOut: "チェックアウト",
    visitOurRooms: "客室を見る",
    Banner: {
      title: "客室を見る",
      description: `ゆっくりと、目を大きく開けて。<0/>中に入ると、歴史の一片が優しくあなたを見つめています。`,
    },
  },
  DateFormat: {
    Default: "DD/MM/YYYY",
    FullDisplay: "HH:mm:ss - DD/MM/YYYY",
    Unit: {
      second: "秒",
      minute: "分",
      hour: "時間",
    },
    Time: "LT",
  },
  SearchControl: {
    room: "客室",
    adults: "大人",
    children: "子供",
    bestPrice: "最安価格保証",
    checkAvailability: "空室状況を確認",
  },
  Time: {
    minutes: "{{n}}分",
  },
  Filter: {
    clearFilter: "フィルターをクリア",
    categoryPlaceholder: "カテゴリー",
    placeholderCategory: "カテゴリー",
    sortPlaceholder: "並び替え",
    lastestLabel: "最新記事",
    oldestLabel: "古い記事",
  },
  Error: {
    pageNotFound: "ページが見つかりません",
    pageNotFoundDescription: "お探しのページは存在しないか、移動された可能性があります。",
    serverError: "サーバーエラー",
    serverErrorDescription: "サーバーで問題が発生しました。後でもう一度お試しください。",
    goHome: "ホームに戻る",
  },
  CookieConsent: {
    message: "サイト体験の向上とトラフィック分析のため、Cookieを使用しています。同意をクリックすると、Cookieの使用に同意したことになります。詳しくは",
    privacyPolicy: "プライバシーポリシー",
    acceptAll: "すべて同意",
    rejectAll: "すべて拒否",
    managePreferences: "設定を管理",
    preferencesTitle: "Cookie設定",
    preferencesDescription: "許可するCookieを選択してください。いつでも設定を変更できます。詳しくは",
    savePreferences: "設定を保存",
    cancel: "キャンセル",
    categoryNecessary: "必須",
    categoryFunctional: "機能",
    categoryAnalytics: "分析",
    categoryMarketing: "マーケティング",
    alwaysRequired: "常にオン",
    categoryNecessaryDesc: "ウェブサイトの動作に必要です。無効にできません。",
    categoryFunctionalDesc: "言語や地域などの設定を記憶します。",
    categoryAnalyticsDesc: "訪問者がサイトをどのように使用しているかを理解し、改善するのに役立ちます。",
    categoryMarketingDesc: "パーソナライズされた広告やマーケティングキャンペーンに使用されます。",
    toggleLabel: "Cookieカテゴリを切り替え",
    cookiePreferences: "Cookie設定",
  },
};
export default ja;

